<template>
    <div class="login">
        <div class="login__background">
            <img src="~@/assets/images/dashboard-background.png" alt="kasanowa" />
        </div>
        <Form :validation-schema="schema" @submit="onSubmit" class="login__wrapper">
            <img src="~@/assets/images/logo.png" alt="kasanowa" />
            <h2 class="login__title">{{ $t('login.login') }}</h2>
            <KTextField
                id="input-email"
                v-model="loginForm.email"
                name="email"
                label=""
                :placeholder="$t('login.email')"
            />
            <KTextField
                id="input-password"
                v-model="loginForm.password"
                name="password"
                label=""
                :placeholder="$t('login.password')"
                type="password"
            />
            <KButton
                id="login-btn"
                :label="$t('login.loginBtn')"
                type="submit"
                full-width
                :loading="loading"
            />
        </Form>
    </div>
</template>

<script setup lang="ts">
import { ref } from '@vue/runtime-core'
import { Form } from 'vee-validate'
import * as yup from 'yup'
import AuthApi from '@/api/v1/AuthApi'
import { toast } from 'vue3-toastify'
import { navigateTo } from '@/hooks/NavigateHooks'
import { useUserStore } from '@/stores/user'
import type { ILoginRequest } from '@/models/AuthModel'
import KTextField from '@/components/atoms/KTextField.vue'
import KButton from '@/components/atoms/KButton.vue'

const loginForm = ref<ILoginRequest>({
    email: null,
    password: null
})
const schema: any = yup.object({
    email: yup
        .string()
        .required(`${t('login.validation.emailRequired')}`)
        .email(`${t('login.validation.email')}user@example.pl`)
        .label('email'),
    password: yup
        .string()
        .required(`${t('login.validation.passwordRequired')}`)
        .label('password')
})

const { logoutUser, loginUser } = useUserStore()
logoutUser()

const loading = ref<boolean>(false)
const authApi = new AuthApi()
const onSubmit = async () => {
    loading.value = true
    const request: ILoginRequest = {
        email: loginForm.value.email,
        password: loginForm.value.password
    }
    try {
        const result = await authApi.login(request)
        if (!result.isSuccess) {
            toast.error(`${t('login.toast.errorLogin')}`)
            loading.value = false
            return
        }
        await loginUser(result.payload)
        await navigateTo('/dashboard')
    } catch (e) {
        toast.error(`${t('login.toast.errorLogin')}`)
        loading.value = false
        return
    }
    loading.value = false
}
</script>

<style scoped lang="scss">
.login {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    margin: 0;
    padding: 0;

    &__background {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;

        img {
            object-fit: cover;
            width: 100%;
            height: 100%;
        }
    }

    &__wrapper {
        padding: 20px;
        border: 1px solid $secondary-400;
        border-radius: 5px;
        background-color: $white;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        min-width: 280px;
        width: 90%;
        box-shadow: 0 0 5px $secondary-400;
        max-width: 550px;

        img {
            position: absolute;
            left: 50%;
            top: -170px;
            transform: translateX(-50%);

            @include media-breakpoint-up(md) {
                top: -115px;
                left: 26px;
            }
        }
    }

    &__title {
        text-align: center;
        margin-bottom: 22px;
        font-size: 28px;
    }
}
</style>
